import { useContext } from "react";
import { AppContext } from "contexts/AppContext";
import SectionWrapper from "components/layouts/SectionWrapper";
import { Box } from "@mui/material";
import { callAPI } from "utils/API";
import { translate } from "utils/Translate";
import Activity from "utils/Activity";
import ProductsScrollBlock from "components/blocks/productsScrollBlock/ProductsScrollBlock";

const PopularProductsSection = () => {
    const { accessibleShops } = useContext(AppContext);
    const ShopID = accessibleShops && accessibleShops.length > 0 ? accessibleShops[0].ShopID : null

    return (
        <SectionWrapper>
            <Box>
                <ProductsScrollBlock
                    category={translate("_HOME_OTHERS_WATCHING_BLOCK_CATEGORY_", "POPULÆRE PRODUKTER")}
                    caption={translate("_HOME_OTHERS_WATCHING_BLOCK_CAPTION_", "Andre kigger på")}
                    fetchProducts={async () => await callAPI("/product/othersLookingProducts", "GET")}
                    onSeeMoreClicked={() => Activity({ activityType: 'click', activityName: 'home', activityArgument: 'Shop', activityArgumentID: ShopID })}
                />
            </Box>
        </SectionWrapper>
    )
}

export default PopularProductsSection